module.exports = __webpack_public_path__ + "img/paishui (2).25e689e5.png";